<template>
  <div>
    <PageHeader title="รายงานการทดลองเรียน"></PageHeader>
    <b-container class="mt-5">
      <div class="section-container">
        <div class="search-section">
          <p>กรุณาระบุข้อมูลที่ต้องการดาวน์โหลดรายงาน</p>
          <b-row>
            <b-col cols="3">
              <label><strong>วันที่สมัครทดลองเรียน</strong></label>
              <div class="date-range-field">
                <b-input-group>
                  <b-form-input
                    size="sm"
                    type="text"
                    :value="formatTrialDate"
                    placeholder="เลือกวันที่สมัครทดลองเรียน"
                    disabled
                  />
                  <b-input-group-prepend>
                    <b-button
                      size="sm"
                      variant="secondary"
                      @click="showCalendarRange('trial-date')"
                    >
                      <b-icon icon="calendar-range"></b-icon>
                    </b-button>
                  </b-input-group-prepend>
                </b-input-group>
                <DatePicker
                  v-model="trialRegistrationDate"
                  locale="th"
                  id="trial-date"
                  :max-date="new Date()"
                  style="
                    display: none;
                    float: right;
                    position: relative;
                    will-change: transform;
                    left: 0px;
                  "
                  is-range
                />
              </div>
            </b-col>
            <b-col v-if="isWannasorn" cols="3">
              <label><strong>สถาบัน</strong></label>
              <b-form-select
                v-model="selectedSubCompany"
                :options="subCompanyOptions"
              ></b-form-select>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="3">
              <label><strong>วิชา</strong></label>
              <b-form-select
                v-model="selectedSubject"
                :options="subjectList"
              ></b-form-select>
            </b-col>
            <b-col cols="5">
              <label><strong>คอร์สที่สมัครทดลองเรียน</strong></label>
              <v-select
                v-if="!isLoadingTrialCourses"
                :options="trialCourseList"
                label="courseName"
                v-model="selectedCourse"
                placeholder="พิมพ์ชื่อคอร์สเรียนที่ต้องการค้นหา"
                :clearable="false"
              />
              <v-select v-else placeholder="กำลังโหลดข้อมูล..." />
            </b-col>
          </b-row>
          <b-button
            @click="searchTrialCourseInfo()"
            class="search-btn"
            variant="primary"
          >
            <b-icon icon="search"></b-icon>
            ค้นหาข้อมูล
          </b-button>
        </div>

        <div v-if="isShowTable" class="table-section">
          <div class="table-title">
            <p>
              <strong>รายละเอียดการทดลองเรียน</strong> คอร์สทั้งหมด
              {{ trialCourseHistoryList.length }} คอร์ส
            </p>
            <b-button @click="generatePdf()" variant="primary">
              <b-icon icon="chevron-double-down"></b-icon>
              ดาวน์โหลดรายงาน pdf
            </b-button>
          </div>
          <p class="remark-text">
            หมายเหตุ : ระบบทำการ generate report เป็นไฟล์ pdf
            และดาวน์โหลดลงบนเครื่องของคุณ
          </p>
          <b-table
            id="trial-course-history-list"
            :fields="fields"
            :items="trialCourseHistoryList"
            :per-page="perPage"
            :current-page="currentPage"
            responsive
            style="font-size: 14px; border:hidden;"
            :busy="isDataTableLoading"
            hover
            striped
            show-empty
          >
            <template slot="table-busy" class="text-center text-danger my-2">
              <Loading />
            </template>
            <template #empty>
              <p class="text-center">ไม่มีข้อมูล</p>
            </template>
            <template v-slot:cell(enrolledAt)="data">
              {{ data.item.startDate | thaiDateFilter }}
            </template>
            <template v-slot:cell(learningTime)="data">
              {{ formattedTime(data.item.learningTime) }}
            </template>
          </b-table>
          <b-row class="mt-3" v-if="trialCourseHistoryList.length > 0">
            <b-col cols="6">
              <form class="form-inline">
                <div class="form-group mb-2">
                  <label>แสดง</label>
                </div>
                <div class="form-group ml-2 mb-2">
                  <b-form-select v-model="perPage" size="sm">
                    <option value="10">10</option>
                    <option value="15">15</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                  </b-form-select>
                </div>
                <div class="form-group ml-2 mb-2">
                  <label>
                    จาก
                    {{ trialCourseHistoryList.length }}
                    รายการ
                  </label>
                </div>
              </form>
            </b-col>
            <b-col cols="6" v-if="trialCourseHistoryList.length > 0">
              <nav class="float-right">
                <b-pagination
                  v-model="currentPage"
                  :per-page="perPage"
                  :total-rows="trialCourseHistoryList.length"
                  aria-controls="trial-course-history-list"
                  last-number
                >
                </b-pagination>
              </nav>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import PageHeader from "../../layouts/PageHeader";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import Loading from "@/components/shared/Loading";
import moment from "moment";
import dateMixin from "@/components/pages/analytics/shared/mixins/date.js";
import vSelect from "vue-select";
import api from "@/services/api";
import trialCourseEnrollReportMixin from "../../../mixins/trial-course-enroll-report-mixin";
import generateAttendanceReportPdfMixin from "../../../mixins/generate-attendance-report-pdf-mixin";
import subCompanyFilterMixin from "../../../mixins/sub-company-filter-mixin";
import { mapActions, mapGetters } from "vuex";

export default {
  mixins: [
    dateMixin,
    trialCourseEnrollReportMixin,
    generateAttendanceReportPdfMixin,
    subCompanyFilterMixin,
  ],
  components: {
    PageHeader,
    DatePicker,
    vSelect,
    Loading,
  },
  data() {
    const currentDate = new Date();

    return {
      comId: this.$store.state.Company.companyInfo.id,
      moment: moment,
      trialRegistrationDate: {
        start: "",
        end: "",
      },
      selectedCourse: "",
      trialCourseList: [{ courseName: "คอร์สทั้งหมด" }],
      isLoadingTrialCourses: true,
      isDataTableLoading: false,
      selectedSubject: "",
      subjectList: [{ value: "", text: "ทั้งหมด" }],
      isShowTable: false,
      perPage: 10,
      currentPage: 1,
      fields: [
        {
          label: "รหัสผู้เรียน",
          key: "studentId",
          formatter: (value) => {
            return value || "-";
          },
        },
        {
          label: "ชื่อผู้เรียน",
          key: "fullName",
        },
        {
          label: "ชื่อคอร์ส",
          key: "courseName",
        },
        {
          label: "วันที่ลงทะเบียน",
          key: "enrolledAt",
        },
        {
          label: "ระยะเวลาเรียน \n (ชั่วโมง:นาที)",
          key: "learningTime",
        },
      ],
      isDisableDownloadReportBtn: false,
      year: currentDate.getFullYear(),
      month: currentDate.getMonth() + 1,
      thaiMonths: [
        "มกราคม",
        "กุมภาพันธ์",
        "มีนาคม",
        "เมษายน",
        "พฤษภาคม",
        "มิถุนายน",
        "กรกฎาคม",
        "สิงหาคม",
        "กันยายน",
        "ตุลาคม",
        "พฤศจิกายน",
        "ธันวาคม",
      ],
      pdfOption: {
        orientation: "p",
        format: "a4",
        unit: "px",
        lineHeight: 1.5,
        putOnlyUsedFonts: true,
      },
      pdfConfig: {
        typo: {
          header: 16,
          large: 18,
          normal: 14,
          small: 12,
          extraSmall: 10,
          chartHeader: 18,
        },
        margin: {
          t: 40,
          b: 20,
          l: 40,
          r: 40,
          tChart: 10,
          tHeaderChart: 24,
          bHeaderTable: 5,
        },
        endNormal: 12,
        endRow: 18,
        endLegend: 32,
      },
    };
  },
  computed: {
    ...mapGetters("ReportManagement", ["trialCourseHistoryList"]),
    courseSummary() {
      const grouped = this.trialCourseHistoryList.reduce((acc, item) => {
        const courseId = item.courseId;

        if (!acc[courseId]) {
          acc[courseId] = {
            courseCode: item.courseCode,
            courseName: item.courseName,
            studentCount: 0,
          };
        }

        acc[courseId].studentCount += 1;
        return acc;
      }, {});

      return Object.values(grouped);
    },
    formatTrialDate() {
      return this.getFormattedRange(
        this.trialRegistrationDate.start,
        this.trialRegistrationDate.end,
        "trial-date",
      );
    },
    selectedSubjectText() {
      const selected = this.subjectList.find(
        (item) => item.value === this.selectedSubject,
      );

      return selected ? selected.text : "ทั้งหมด";
    },
  },
  async mounted() {
    let courses = [];
    let subjects = [];

    this.setDefaultDates();

    await api.get(`v1/companies/${this.comId}/courses`).then(({ data }) => {
      courses = data.data.filter((item) => item.courseOnlineType == "TRIAL");
      this.isLoadingTrialCourses = false;
    });

    this.trialCourseList.push(...courses);

    await api.get(`/v1/courses/academic-data`).then(({ data }) => {
      subjects = data.data.subjects.map((item) => {
        return { value: item.st_id, text: item.st_name };
      });
    });

    this.subjectList.push(...subjects);

    if (this.isWannasorn) {
      this.loadSubCompanyDropdown();
    }
  },
  methods: {
    ...mapActions("ReportManagement", ["fetchTrialCourseHistoryList"]),
    async fetch(params) {
      this.isDataTableLoading = true;
      await this.fetchTrialCourseHistoryList(params);
      this.isDataTableLoading = false;
    },
    async searchTrialCourseInfo() {
      let params = {
        courseName:
          this.selectedCourse?.courseName === "คอร์สทั้งหมด"
            ? null
            : this.selectedCourse?.courseName,
        subjectId: this.selectedSubject || null,
        startDateFrom: this.trialRegistrationDate.start
          ? moment(this.trialRegistrationDate.start).format("YYYY-MM-DD")
          : "",
        startDateTo: this.trialRegistrationDate.end
          ? moment(this.trialRegistrationDate.end).format("YYYY-MM-DD")
          : "",
        scId: this.selectedSubCompany || null,
      };

      await this.fetch(params);
      this.isShowTable = true;
    },
    getFormattedRange(startDate, endDate, calendarId) {
      if (!startDate) return "";

      const rangeCalendar = document.getElementById(calendarId);
      if (rangeCalendar && rangeCalendar.style.display === "inline-block") {
        this.showCalendarRange(calendarId);
      }

      const start = moment(startDate).format("DD/MM/YYYY");
      const end = moment(endDate).format("DD/MM/YYYY");
      return `${start} - ${end}`;
    },
    showCalendarRange(calendarId) {
      let rangeCalendar = document.getElementById(calendarId);
      if (rangeCalendar.style.display == "inline-block") {
        rangeCalendar.style.display = "none";
      } else {
        rangeCalendar.style.display = "inline-block";
      }
    },
    formattedTime(second) {
      const hours = Math.floor(second / 3600);
      const minutes = Math.floor((second % 3600) / 60);

      const displayHours = String(hours).padStart(2, "0");
      const displayMinutes = String(minutes).padStart(2, "0");

      return `${displayHours}:${displayMinutes}`;
    },
    setDefaultDates() {
      const dateFormat = "YYYY-MM-DD";
      const currentDate = moment();
      const ninetyDaysAgo = moment(currentDate).subtract(90, "days");

      this.trialRegistrationDate.start = ninetyDaysAgo.format(dateFormat);
      this.trialRegistrationDate.end = currentDate.format(dateFormat);
    },
  },
};
</script>

<style scoped lang="scss">
.section-container,
.search-section {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

.search-section {
  .date-range-field,
  .date-field {
    .form-control:disabled {
      background-color: #fff;
    }
  }

  .search-btn {
    width: fit-content;
  }
}

.table-section {
  display: flex;
  flex-direction: column;
  gap: 25px;

  .table-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
  }

  .remark-text {
    color: #ffc107;
  }
}
/* Calendar */
.vc-container {
  position: absolute !important;
  right: 0 !important;
  left: initial !important;
  margin-right: 13px;
  z-index: 99;
}

/* Target the input search and its placeholder */
::v-deep .vs__search,
::v-deep .vs__search::placeholder {
  margin: 0;
  padding: 3px 3px 2px;
  font-size: 14px;
}
</style>

<style>
/* text field height */
.date-range-field .form-control,
.vs__dropdown-toggle {
  height: 38px;
}

.vs__dropdown-toggle {
  align-items: center;
}

.vs__clear {
  margin-bottom: 6px;
}

.custom-select {
  height: 38px !important;
  padding: 0 1.75rem 0 0.75rem;
  font-size: 14px !important;
}
</style>
